<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer
               class="sidenav" fixedInViewport
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               mode="over"
               autoFocus="false">
    <mat-toolbar class="menu-toolbar">
      <ng-container *ngIf="this.line; else noLine">
        <div class="header">
          {{this.line.factoryName}}
          <div class="sub-header">{{this.line.name}}</div>
        </div>
      </ng-container>
      <ng-template #noLine>Menu </ng-template>
    </mat-toolbar>
    <mat-nav-list>
      <ng-container *ngFor="let group of this.groupedRoutes">
        <div mat-subheader>{{group.name}}</div>
        <a *ngFor="let item of group.routes"
           mat-list-item
           [routerLink]="item.routeParts"
           [disabled]="item.disabled"
           routerLinkActive="is-active-route"
           [routerLinkActiveOptions]="{ exact: item.matchExact }"
           (click)="drawer.toggle()">
          <mat-icon mat-list-icon>{{item.icon}}</mat-icon>
          {{item.name}}
        </a>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="full-height-container">
    <mat-toolbar color="{{userSessionService.isLoggedIn ? 'primary' : undefined}}">
      <button type="button"
              aria-label="Toggle sidenav"
              mat-icon-button
              (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <svg xmlns="http://www.w3.org/2000/svg" width="57.59" height="63.43" viewBox="0 0 128.497 141.515" class="unilever-header-logo">
        <use href="/assets/unilever-logo.svg#logo" [ngStyle]="{'fill': userSessionService.isLoggedIn ? '#fff' : '#1f36c7'}"/>
      </svg>
      <span>Changeover App</span>
      <div *ngIf="this.liveUpdatesAvailable !== false" class="mclaren-brand">
        <span [ngStyle]="{'color': userSessionService.isLoggedIn ? '#fff' : '#000'}">Accelerated by</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="158" height="40" viewBox="0 0 261.817 66.893">
            <use *ngIf="userSessionService.isLoggedIn;else black_logo" href="/assets/mclaren-logo.svg#logo-white"/>
            <ng-template #black_logo>
              <use href="/assets/mclaren-logo.svg#logo-black"/>
            </ng-template>
        </svg>
      </div>
      <span class="flex-spacer"></span>
      <button *ngIf="this.liveUpdatesAvailable === false"
              mat-button
              class="liveupdate-error"
              (click)="this.forceReload()"
              >
        <mat-icon>warning</mat-icon>
        <div class="message">
          <div>Live updates reconnecting...</div>
          <div class="fine-print">If this persists, tap here to reload</div>
        </div>
      </button>
      <span class="flex-spacer"></span>
      <div class="user-menu">
        <button *ngIf="!userSessionService.isLoggedIn"
                type="button"
                class="sign-in-btn"
                aria-label="Sign In"
                (click)="userSessionService.signIn()"
                mat-flat-button>
          <mat-icon aria-hidden="false" aria-label="User avatar placeholder icon">
            person_outline
          </mat-icon>
          SIGN IN
        </button>

        <button *ngIf="userSessionService.isLoggedIn"
                mat-button
                [matMenuTriggerFor]="userMenu">
          <mat-icon *ngIf="!this.userSessionService.photoUrl"
                    aria-hidden="false"
                    aria-label="User avatar icon">
            person_outline
          </mat-icon>
          <img *ngIf="this.userSessionService.photoUrl"
               aria-label="User avatar icon"
               alt="User avatar icon"
               class="user-photo"
               [src]="this.userSessionService.photoUrl" />

          {{userSessionService.displayName}} {{this.line ? ' at ' + this.line.name : ''}}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #userMenu xPosition="before">
          <ng-container *ngIf="this.line">
            <div class="session-info">
              {{this.line.factoryName}} — {{this.line.name}}
            </div>
            <mat-divider></mat-divider>
          </ng-container>
          <button mat-menu-item (click)="this.openLinePicker()">
            <mat-icon>room_preferences</mat-icon>
            Change Line
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="userSessionService.signOut()">
            <mat-icon>logout</mat-icon>
            Sign out
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>

    <router-outlet>
    </router-outlet>

  </mat-sidenav-content>
</mat-sidenav-container>